import React from 'react'
import { NavLink } from 'react-router-dom'
import { useGlobalContext } from './context'
import './app.css'

const Movies = () => {
  const { movie, isLoading } = useGlobalContext();
  if (isLoading) {
    return <div className='loading'>Loading....</div>;
  }
  return (
    <>
    <section className='movies-page'>
       <div className='container movies'>             
        {movie.map((curMovie)=>{
          const {imdbID,Title,Poster}=curMovie;
          const movieTitle= Title.substring(0,15)
           return(
           <>
                <NavLink to={`movie/${imdbID}`}  key={imdbID}>
                <div className='card'>
                  <div className='card-info'>
                  <h2>{movieTitle.length >=15 ? `${movieTitle}...`: movieTitle}</h2>
                   <img src={Poster} alt={imdbID} />
                  </div>
                </div>    
            </NavLink>
            </>
           )
        })}
        </div>    
    </section>
    </>
  )
}

export default Movies